/* tslint:disable */
/* eslint-disable */
/**
 * comici-plus-api
 * # Comici Plus API v1  コンテンツプロバイダーがコンテンツの配信サイトを作成するために利用するAPIを提供します。 
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * モバイル決済リクエスト
 * @export
 * @interface MobilePaymentRequestModel
 */
export interface MobilePaymentRequestModel {
    /**
     * 購入するコインのポイントタイプID
     * @type {number}
     * @memberof MobilePaymentRequestModel
     */
    pointTypeId: number;
    /**
     * 決済方法
     * @type {string}
     * @memberof MobilePaymentRequestModel
     */
    paymentType: MobilePaymentRequestModelPaymentTypeEnum;
    /**
     * 決済通貨
     * @type {string}
     * @memberof MobilePaymentRequestModel
     */
    currencyType: MobilePaymentRequestModelCurrencyTypeEnum;
    /**
     * Stripeから取得したトークンオブジェクトJSON文字列
     * @type {object}
     * @memberof MobilePaymentRequestModel
     */
    stripeToken: object;
    /**
     * Stripe側の決済情報に含めるメッセージ
     * @type {string}
     * @memberof MobilePaymentRequestModel
     */
    message: string;
}


/**
 * @export
 */
export const MobilePaymentRequestModelPaymentTypeEnum = {
    ApplePay: 'applePay',
    GooglePay: 'googlePay'
} as const;
export type MobilePaymentRequestModelPaymentTypeEnum = typeof MobilePaymentRequestModelPaymentTypeEnum[keyof typeof MobilePaymentRequestModelPaymentTypeEnum];

/**
 * @export
 */
export const MobilePaymentRequestModelCurrencyTypeEnum = {
    Jpy: 'jpy',
    Usd: 'usd',
    Eur: 'eur',
    Cny: 'cny'
} as const;
export type MobilePaymentRequestModelCurrencyTypeEnum = typeof MobilePaymentRequestModelCurrencyTypeEnum[keyof typeof MobilePaymentRequestModelCurrencyTypeEnum];


/**
 * Check if a given object implements the MobilePaymentRequestModel interface.
 */
export function instanceOfMobilePaymentRequestModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "pointTypeId" in value;
    isInstance = isInstance && "paymentType" in value;
    isInstance = isInstance && "currencyType" in value;
    isInstance = isInstance && "stripeToken" in value;
    isInstance = isInstance && "message" in value;

    return isInstance;
}

export function MobilePaymentRequestModelFromJSON(json: any): MobilePaymentRequestModel {
    return MobilePaymentRequestModelFromJSONTyped(json, false);
}

export function MobilePaymentRequestModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): MobilePaymentRequestModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'pointTypeId': json['pointTypeId'],
        'paymentType': json['paymentType'],
        'currencyType': json['currencyType'],
        'stripeToken': json['stripeToken'],
        'message': json['message'],
    };
}

export function MobilePaymentRequestModelToJSON(value?: MobilePaymentRequestModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'pointTypeId': value.pointTypeId,
        'paymentType': value.paymentType,
        'currencyType': value.currencyType,
        'stripeToken': value.stripeToken,
        'message': value.message,
    };
}

